import { Component, OnInit, ViewChildren,ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { HelperService } from 'src/app/services/helper.service';
import { ModalController, NavController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { IonInfiniteScroll } from '@ionic/angular';
//import { IonicRatingModule } from 'ionic4-rating';
import * as _ from 'lodash';
import { AlertController } from '@ionic/angular';
import { LoadingService } from 'src/app/services/loading.service';


@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.page.html',
  styleUrls: ['./order-history.page.scss'],
})
export class OrderHistoryPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  rate: any = 0;
  userId: any = localStorage.getItem('userId');
  orderConfirmObj: any = [];
  page_number: number = 1;
  modelData: any;
  limit = 10;
  noDataImage: boolean = false;
  isLoading: boolean = false;
  review: boolean;
  flag: any;
  data: any = [];
  skipRole: any;
  created: boolean = true;
  delivered: boolean = false;
  count: any;
  segment = "card";
  OrderItem: any = [];
  offset: any = 0;
  len: any = [];
  orderIds: any;
  mainData: any = [];
  a: boolean = false;
  amount: any = 0;
  check: any = [];
  constructor(
    private loader: LoadingService,
    public alertController: AlertController,
    private user: UserService,
    public modalController: ModalController,
    private toast: HelperService,
    private routerActivate: ActivatedRoute,
    private router: Router,
    private service: StoreService,
    private navController: NavController,) { }

  ngOnInit() {
    // this.orderHistory();
  }

  ionViewDidEnter() {
    this.OrderItem = [];
    this.orderHistory();
  }

  orderHistory(loaded = false, event?) {
    console.log(event)
    if (loaded) {
      this.offset += 1;
    }

    this.delivered = false;
    this.created = true;
    this.isLoading = true;

    const promoListobj = {
      userId: this.user.uid,
      limit: 30,
      offset: this.offset
    }

    this.user.setContext('Order History request', promoListobj);
    let name = '[LOG] Get Order History';
    var error = new Error();
    error.name = name;
    this.user.sendException(error)

    this.service.orderHistoryAPI(promoListobj).then((data: any) => {
      this.check = data;
      this.isLoading = false;
      let grouped = _.groupBy(data, 'orderId')
      this.orderIds = Object.keys(grouped)
      this.mainData = grouped;
      console.log("ggggggggggggggg",data)
      if (this.check.length > 0) {
        this.OrderItem = [...this.OrderItem, ...this.orderIds];
      }
      for (let x in this.mainData) {
        {
          for (let y in this.mainData[x]) {
            this.amount = this.amount + parseInt(this.mainData[x][y].purchaseAmount)
          }
          this.amount = 0
        }
      }

      grouped = _.groupBy(this.OrderItem, 'orderId')
      this.len = data;
      if (this.OrderItem.length == 0) {
        this.noDataImage = true;
      }
      if (event) {
        event.target.complete();
      }
    })

  }

  notifications() {
    this.router.navigate(['/wishlist'])
  }

  doInfinite(event) {
    this.orderHistory()
  }

  goHome() {
    this.router.navigate(['/'])
  }

  continueShopping() {
    this.navController.navigateRoot('/');
  }

  orderDetails(cat: any) {
    //console.log(cat)
    let navigationParams: NavigationExtras = { state: { cat } };
    this.router.navigate(['/order-history-detail'], navigationParams)
  }

  goBack() {
    this.navController.back();
  }

  getStatus(status) {
    if (status == -1)
      return 'Payment Cancelled'
    if (status == 0)
      return 'Placed'
    if (status == 1)
      return 'Store Accepted Order'
    if (status == 2)
      return 'Store Rejected Order'
    if (status == 3)
      return 'Order Packed'
    if (status == 4)
      return 'Delivery Rejected'
    if (status == 5)
      return 'Delivered'
    if (status == 6)
      return 'Customer Declined'
    if (status == 7)
      return 'Cancelled'
    if (status == 8)
      return 'Return/Refund Request'
  }

  getStatusClass(status) {
    if (status == -1 || status == 2 || status == 4 || status == 6 || status == 7)
      return 'cancelled'
    else if (status == 8)
      return 'primary'
    else
      return 'placed'
  }

  async collectCoin(data) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Confirm!',
      message: " <strong>You can't  replace or return the product after collect the coins</strong>!!!",
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',

          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirm',
          id: 'confirm-button',
          handler: () => {
            this.loader.presentLoading("");
            console.log('Confirm Okay');
            let formData = {
              orderId: data.orderId,
              id: data.productId
            }
            console.log(formData)
            this.service.colllectCoins(formData).subscribe((res) => {
              console.log(res);
              data.coinsCollected = true;
              this.loader.dismiss();
            })
          }
        }
      ]
    });

    await alert.present();
  }

  handleMissingImage($event) {
    console.log($event)
    console.log("hello error");
    ($event.target as HTMLImageElement).style.display = 'none'
    this.a = true;
  }

}

